import { TemplateData, TemplateParams } from '.';

const register = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'common',
  email: {
    buttonEnabled: true,
    buttonLink: '{{createAccountUrl}}',
    buttonText: messages.createAccount,
    content: `
      <p>
        ${messages.newUserStartContent}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.newUserInfo}
      </p>
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.newUserSubject}`
  },
  placeholders: {
    createAccountUrl: {
      label: messages.createAccountLink,
      example: `${serverConfig.adminUrl}/create-account?key=123`
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeRegister
});

export default register;
